import { render, staticRenderFns } from "./SchoolyearPlanningActivities.vue?vue&type=template&id=dda774aa&scoped=true"
import script from "./SchoolyearPlanningActivities.vue?vue&type=script&lang=js"
export * from "./SchoolyearPlanningActivities.vue?vue&type=script&lang=js"
import style0 from "./SchoolyearPlanningActivities.vue?vue&type=style&index=0&id=dda774aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda774aa",
  null
  
)

export default component.exports